export { default } from 'common/services/error-handler';
